// lang-es.ts

export const LANG_NL_NAME = "nl";

export const LANG_NL_TRANS = {
  LblWeekdays: {
    shorthand: ["Zo", "Ma", "Di", "Wo", "Do", "Vr", "Za"],
    longhand: [
      "Zondag",
      "Maandag",
      "Dinsdag",
      "Woensdag",
      "Donderdag",
      "Vrijdag",
      "Zaterdag"
    ]
  },
  LblMonths: {
    shorthand: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "Mei",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Okt",
      "Nov",
      "Dec"
    ],
    longhand: [
      "Januari",
      "Februari",
      "Maart",
      "April",
      "Mei",
      "Juni",
      "Juli",
      "Augustus",
      "September",
      "Oktober",
      "November",
      "December"
    ]
  },
  LblButtonText: {
    today: "Vandaag",
    month: "Maand",
    week: "Week",
    day: "Dag",
    list: "Lijst"
  },
  LblEdit: "Bewerken",
  LblDelete: "Verwijderen",
  LblRemove: "Verwijderen",
  LblActiveInactive: "Actief/Inactief",
  LblActive: "Actief",
  LblInactive: "Deaktiveren",
  LblAddNew: "Toevoegen",
  LblAdd: "Toevoegen",
  LblUpdate: "Wijzigen",
  LblSave: "Opslaan",
  LblCancel: "Annuleren",
  LblReset: "Reset",
  LblSelect: "Selecteer",
  LblSuccess: "Gelukt",
  LblWarning: "Waarschuwing",
  LblList: "Lijst",
  LblAssign: "Toewijzen aan",
  LblHome: "Home",
  LblYes: "Ja",
  LblOK: "Ok",
  LblNo: "Nee",
  LblBack: "Terug",
  LblReason: "Reden",
  LblRecordSavedSuccess: "Opslaan gelukt",
  LblRecordDeleteSuccess: "Verwijderen gelukt",
  LblResetPasswordSuccess: "Wachtwoord gereset",
  LblBookingApproveRejectSuccess: "%0 %1 succesvol",
  LblRecordAddedSuccess: "%0 toegevoegd",
  LblRecordUpdatedSuccess: "%0 wijzigen gelukt",
  LblRecordRemovedSuccess: "%0 verwijderd",
  LblRecordActiveInActiveSuccess: "%0 %1 gelukt",
  LblinvoiceResendSuccess: "%0 opnieuw verzonden",
  LblRecordBlokUnBlockSuccess: "%0 %1 gelukt",
  LblConfirm: "Bevestigen",
  LblContactPersonAddedSuccess: "Contactpersoon toegevoegd",
  LblBlockUnblockConfirm: "Weet je zeker dat je de %1 wilt %0?",
  LblRecordDeleteConfirmation: "Weet je zeker dat je %0 wilt verwijderen?",
  LblRecordMultiplDeleteConfirmation:
    "Weet je zeker dat je de selectie wilt verwijderen?",
  LblConfirmMessage: "Weet u het zeker?",
  LblResetPassword: "Reset wachtwoord",
  LblResetPasswordConfirmation:
    "Weet je zeker dat je je wachtwoord wilt resetten?",
  LblGeoLocationError: "Voer een correcte geolocatie in",
  LblPersonDeleteCheck: "Verwijder permanent",
  LblBookingCancelSuccess: "Reserveringen annuleren is gelukt",
  LblBookingAbortSuccess: "Reservering afbreken is gelukt",
  LblBookingRevokeSuccess: "Reservering intrekken is gelukt",
  LblContactPersonRemoveSuccess: "Contactpersoon verwijderd",
  LblNoRecords: "Geen regels beschikbaar",
  LblAffectedBookingList: "Lijst met betrokken reserveringen",
  LblSubscriptionEndDateError: "Voer einddatum van abonnement in",
  LblIsSpecialPeriodAllow: "Wil je kosten voor speciale periode toepassen?",
  LblContractSlotisnotdefined:
    "Contracttype voor hieronder gegeven tijd slot is niet gedefinieerd",
  LblUnscubscribeSuccess: "Succesvol uitgeschreven",
  LblModifiedBy: "Gewijzigd door",
  LblModifiedDate: "Wijzigingsdatum",
  LblInstance: "Instantie",
  LblInstanceName: "Instantienaam",
  LblInstanceType: "Instantietype",
  LblDescription: "Omschrijving",
  LblCurrencySymbol: "Symbool van valuta",
  LblPreferredLanguage: "Taal",
  LblTimeZone: "Tijdzone",
  LblCurrencyAbbreviation: "Valuta afkorting",
  LblInstanceDeleteValidation:
    "Kan Instance niet verwijderen omdat deze aan andere entiteit refereert",
  LblIsBookingApprovalReq: "Goedkeuring reservering vereist",
  LblKilometers: "Kilometers",
  LblKM: "Km",
  LblDeletePersonNote: "In afwachting van facturen voor deze persoon zal niet worden verzonden",
  LblInstanceConfiguration: "Service Configuratie",
  LblBookingAlertTime: "Boeking waarschuwingstijd",
  LblBookingCancelTime: "Boeking annuleringstijd",
  LblBookingTemporaryTime: "Reservering Bevestiging Tijd",
  LblVtsRequestTimeout: "VTS aanvraag - geen reactie",
  LblVtsTripLogTimeout: "VTS ritlog - geen reactie",
  LblEmailConfiguration: "E-mail configuratie (SMTP)",
  LblInSeconds: "In Seconden",
  LblFromEmail: "Verzend mailadres",
  LblHost: "Gastheer",
  LblPort: "Port",
  LblEnableSsl: "Enable SSL",
  LblSmtpEmail: "SMTP Email",
  LblIsImportPersonAllow: "Persoon importeren toestaan",

  LblValidateLiceanceNumber: "Rijbewijs controle",
  LblValidateLicenseA2SP: "A2SP Rijbewijs controle",
  LblValidateLicense24IDCheck: "24ID Rijbewijs controle",
  LblValidateLicenseForAllBookings: "Rijbewijs controle elke boeking uitvoeren",

  LblGeofenceLocation: "Geofence locatie",
  LblRadius: "Straal",
  LblEmailRecepients: "Email Ontvangers",
  LblRecepients: "Ontvangers",
  LblEmailAddresses: "Email addresses",
  LblMap: "Kaart",

  // AFAS/Azure Config
  LblImportConfiguration: "Import Configuratie",
  LblImportConnectionType: "Connection Type",
  LblAfas: "AFAS",
  LblAzure: "Azure",
  LblAzureTenantId: "Azure Tenant ID",
  LblAzureClientId: "Azure Client ID",
  LblAzureClientSecret: "Azure Client Secret",
  LblAfasClientId: "AFAS Client ID",
  LblAfasConnectorName: "AFAS connector naam",
  LblAfasConnectionType: "AFAS connectie type",
  LblAfasTest: "Test",
  LblAfasAccept: "Acceptatie",
  LblAfasProduction: "Productie",
  LblAfasToken: "AFAS Token",
  LblAfasClientIdError: "Voer AFAS Client ID in",
  LblAfasConnectorNameError: "Voer AFAS Client ID in",
  LblAfasConnectionTypeError: "Voer AFAS Connection Type in",
  LblAfasTokenError: "Voer AFAS-Token in",
  LblAzureTenantIdError: "Voer Azure Tenant ID in",
  LblAzureClientIdError: "Voer Azure Client ID in",
  LblAzureClientSecretError: "Voer Azure Client Secret in",

  // SSO Config
  LblSsoConfiguration: "SSO Configuratie",
  LblDefaultSsoSharedVehicleGroup: "Standaard poolgroep",
  LblDefaultSsoOrganization: "Standaard organisatie",
  LblDefaultSsoSubscription: "Standaard abonnement",

  // Dropoff Message
  LblDropoffMessageConfiguration: "Dropoff Message Configuratie",
  LblDropoffMessageExternalUrl: "Externe Url",
  LblDropoffMessageApiKey: "Api Key",
  LblDropoffMessageActive: "Actief",

  LblBookingCalanderSettings: "Kalenderinstellingen",
  LblShowDriverInfo: "Toon bestuurdersinformatie in kalender",
  LblOrganizationAdmin: "Organisatiebeheerder",
  LblDriverInfoToShow: "Bestuurdersinformatie die wordt getoond",

  LblValidate: "Valideer",
  LblBookingCancelTimeMessage:
    "Dit definieert de tijd (in seconden) waarna het annuleren van een boeking niet meer mogelijk is",
  LblBookingTemporaryTimeMessage:
    "Tijd voor voorlopige boeking. Nadat de gebruiker het voertuig heeft geselecteerd om te boeken maar deze nog niet is bevestigd.",
  LblVtSRequestTimeoutMessage:
    "Geen reactie voor het ontgrendel / vergrendel commando in de App",
  LblVtsTriplogTimeoutMessage:
    "Geen reactie voor tripberekening na uitvoering van het vergrendel commando",
  LblContractTypeDeleteValidation:
    "Kan Contract Type Group niet verwijderen omdat deze met een andere entiteit is gekoppeld",

  LblUserName: "Gebruikersnaam",
  LblFirstName: "Voornaam",
  LblLastName: "Achternaam",
  LblEmail: "E-mail",
  LblMobileNumber: "Mobiel nr.",
  LblPhoneNumber: "Telefoon",
  LblHomeAddress: "Adres privé",
  LblWorkAddress: "Werkadres",
  LblHouseNo: "Huisnr.",
  LblHouseExtention: "Toevoeging",
  LblStreetName: "Straat",
  LblCity: "Stad",
  LblZipCode: "Postcode",
  LblPassword: "Wachtwoord",
  LblConfirmPassword: "Bevestig wachtwoord",
  LblMiddleName: "Tussenvoegsel",
  LblCompany: "Bedrijf",
  LblCompanyName: "Bedrijfsnaam",
  LblContactPerson: "Contactpersoon",
  LblCompanyAdmin: "Company Admin",
  LblCompanyAddress: "Bedrijfsadres",
  LblApkExiprationSetting: "APK-meldingsinstellingen",
  LblNotificationFrequency: "Meldingsfrequentie",
  lblThresholdFrequency: "Frequentie van vooraf waarschuwen",
  lblThresholdTimeInterval: "Hoe vaak waarschuwingen vooraf",
  LblIsEmailEnabled: "E-mail bericht",
  LblEnabled: "Ingeschakeld",
  LblDisabled: "Uitgeschakeld",

  LblFrequency: "Frequentie",
  LblApkTimeInterval: "Tijdsinterval waarschuwingen",
  LblEmailNotification: "Email bericht",
  LblWeek: "WEEK",
  LblMonth: "Maand",
  lblPerBooking: "Perreservering",
  LblInternalOrganization: "Interne organisatie",
  LblNoOfVegicles: "Aantal voertuigen",
  LblNoOfSharedVehicleGroups: "Aantal poolgroepen",
  LblGeoLocation: "Locatie",
  LblSelectGeoLocation: "Selecteer een locatie",
  LblPerson: "Persoon",
  LblRole: "Rollen",
  LblDateOfBirth: "Geboortedatum",
  LblDriverLicenceNumber: "Rijbewijsnummer",

  LblPersons: "Personen",
  LblPersonOverview: "Persoonoverzicht",
  LblCompanies: "Bedrijven",

  LblVehicle: "Voertuig",
  LblVtsVehicle: "VTS voertuig",
  LblLicenceTag: "Kenteken",
  LblLicence: "Rijbewijs",
  LblMobile: "Mobiel",
  LblVehicleOwner: "Voertuigeigenaar",
  LblLocationDataExchange: "Locatie data uitwisseling",
  LblBrand: "Merk",
  LblType: "Type",
  LblColor: "Kleur",
  LblVehicleClass: "Voertuigklasse",
  LblPricingCategory: "Prijsklasse",
  LblBodyStyle: "Carrosserievorm",
  LblAvailable: "Beschikbaar",
  LblUnAvailable: "Onbeschikbaar",
  LblAvailableFrom: "Beschikbaar vanaf",
  LblAvailableTo: "Beschikbaar tot",
  LblFuelType: "Brandstofsoort",
  LblMinBookingTimeBefore: "Minimale tijd  vrij voor reservering (minuten)",
  LblMinBookingTimeAfter: "Minimale tijd vrij na reservering (minuten)",
  LblTowbar: "Trekhaak",
  LblAirco: "Airco",
  LblApkExpirationDateCet: "APK-vervaldatum",
  LblVehicleAttributes: "Voertuigkenmerken",
  LblBlockUnBlock: "Blokkeren/Deblokkeren",
  LblRemoveLicense: "Remove License",
  LblRemoveLicenseBirthDate: "Remove License and Birth Date",
  LblLicenseBirthDate: "Geboortedatum",
  LblBlock: "Blokkeren",
  LblUnblock: "Deblokkeren",
  LblAvailableUnAvailable: "Beschikbaar/Onbeschikbaar",
  LblIntialOdometerValue: "Begin kilometerstand",
  LblVehicles: "Voertuigen",
  LblBookingsOverview: "Boekingsoverzicht",
  LblFuelCardPinCode: "Pincode voor brandstofkaart",


  LblFuel: "Brandstof",
  LblVINnumber: "VIN nummer",
  LblVehicletype: "Voertuig type",
  LblDoors: "Aantal deuren",
  LblWeight: "Gewicht voertuig",
  LblTrunkSpace: "Kofferbakruimte",
  LblGears: "Aantal versnellingen",
  LblEngineHorsepower: "Motor (pk)",
  LblFuelConsumption: "Opgegeven verbruik",
  LblSeats: "Aantal zitplaatsen",
  LblDimensions: "Afmetingen voertuig",
  LblTransmissionType: "Soort transmissie",
  LblTransmissionUnknown: "Onbekend",
  LblManualTransmission: "Handgeschakeld",
  LblAutomaticTransmission: "Automaat",

  LblVehicleDetails: "Voertuig details",
  LblSelectVehicletype: "Kies voertuig type",
  LblWrongVinNumber: "Ongeldig VIN nummer",
  
  //WEGO2DEV-325(Settings for Dashboard statuses)
  LblVehicleOnSameLocationTime: "Voertuig op zelfde locatie langer dan",
  LblNoBookingIn: "Geen boeking in meer dan",

  lblHour: "Uur",
  lblHourDayWeekMonth: "Uur / dag / week / maand",

  LblSharedVehicleGroup: "Poolgroep",
  LblVehicleGroup: "Voertuiggroep",
  LblSharedVehicleGroupAdmin: "Poolgroepbeheerder",
  LblDisplayPeriod: "Weergave periode",
  LblBookingWeekDays: "Weekdagen boeken",
  LblBookingInterval: "Boekingsinterval (minuten)",
  LblBookingStartTime: "Starttijd van de boeking (uu:mm)",
  LblBookingEndTime: "Eindtijd boeking (uu:mm)",
  LblBookingMinDuration: "Minimale boekingsduur (minuten)",
  LblBookingMaxDuration: "Maximale boekingsduur (minuten)",
  LblMaxRecurringBooking: "Maximaal aantal herhalingen",
  LblPreBookingInterval: "Tijdbuffer voor reservering (minuten)",
  LblPostBookingInterval: "Tijdbuffer na reservering (minuten)",
  LblBookingExtensionTime: "Max. verlengingstijd reserveren (minuten)",
  LblBookAheadTime: 'Boeking mogelijk "X" minuten na nu',
  LblBookingHorizon: "Reserveringshorizon",
  LblDay: "Dag",
  LblNumberOfContactTypeGroup: "Aantal Contracttype groepen",
  LblNumberOfContactType: "Aantal Contracttypen",
  LblInvoiceInterval: "Factuurinterval",
  LblIsBookingIntervalAlignToCalendar:
    "Tijdkeuze boeking conformeren aan tijdblok",
  LblEarlyOpenInterval: "Eerder openen interval (minuten)",

  LblFeatureFlags: "Functies",
  LblCreateBooking: "Boeking maken",
  LblEditBooking: "Boeking bewerken",
  LblLicenseCheck: "Rijbewijs controle",
  LblBookingLicenseCheck: "Boeking rijbewijs controle",

  LblBookings: "Boekingen",
  LblSharedVehicleGroups: "Poolgroepen",
  LblSharedVehicleGroupOverview: "Poolgroep overzicht",

  LblDriver: "Bestuurder",
  LblLicenceNumber: "Rijbewijsnummer",
  LblDriverName: "Naam bestuurder",
  LblDriverSVG: "Poolgroep bestuurder",
  LblDriverUserName: "Gebruikersnaam Bestuurder",
  LblSelectFuelType: "Kies brandstofsoort",
  LblSelectPricingCatagory: "Kies prijsklasse",
  LblSelectBodyStyle: "Kies carrosserie",
  LblSelectVehicleClass: "Kies voertuigklasse",
  LblVehicleAttributeCategory: "Voertuigkenmerk categorie",
  LblVehicleAttributeName: "Kenmerk",
  LblVehicleAttributeDesc: "Omschrijving",
  LblVehicleAttribute: "Voertuigkenmerk",
  LbAdditionallVehicleAttribute: "Extra kenmerken",

  LblVehicleAttributeCategories: "Categorie\u00EBn voor voertuigattributen",

  LblRegular: "Regulier",
  LblWeekEnd: "Weekend",
  LblDayCT: "Dag",
  LblExtraTimeBefore: "Extra tijd eerder (minuten)",
  LblExtraTimeAfter: "Extra tijd na (minuten)",
  LblFreeTextDescription: "Geef het tarief, begin- en eindtijden van de speciale boekig op (vrije tekst)",
  LblPeriodRate: "Periodetarief",
  LblPeriodRateVat: "Periodetarief BTW",
  LblSelectContractTypeType: "Selecteer type contracttype",
  LblContractTypeType: "Contract type type",
  LblContractType: "Contract Type",
  LblContractName: "Contractnaam",
  LblContractTypeGroup: "Contract Type Groep",
  LblContractTypeGroupName: "Contract Type Groep naam",
  LblContractAvailableDays: "Contract beschikbare dagen",
  LblApplicableDays: "Dagen van toepassing",
  LblDayStartTime: "Dag starttijd (uu:mm)",
  LblDayEndTime: "Dag eindtijd (uu:mm)",
  LblApplicableStartTime: "Toepasselijke starttijd (uu:mm)",
  LblApplicableEndTime: "Van toepassing zijnde eindtijd (uu:mm)",
  LblComment: "Opmerking",
  LblProcessingFee: "Verwerkingskosten",
  LblTripDisplayType: "Hoe moeten ritten in de rapporten worden getoond?",
  LblAllTripsIndividually: "Alle ritten afzonderlijk",
  LblAllTripsGrouped: "Alle ritten gegroepeerd in een enkele rit",
  LblVatPercentage: "BTW percentage",
  LblVatIncludedInPrice: "Incl. BTW",
  LblPlateformUsageCost: "Gebruikskosten van het platform",
  LblCatA: "Categorie A",
  LblCatB: "Categorie B",
  LblCatC: "Categorie C",
  LblCatD: "Categorie D",
  LblCatE: "Categorie E",
  LblCatF: "Categorie F",
  LblCatG: "Categorie G",
  LblCatH: "Categorie H",
  LblHourlyRate: "Kosten huurtijd",
  LblMileageRate: "Kilometerprijs",
  LblFixedFee: "Vaste kosten",
  LblPricingModel: "Prijsmodel",
  LblContractStartDateTime: "Startdatum contract",
  LblContractEndDateTime: "Contract einddatum/tijd",
  LblContractTypeHistory: "Geschiedenis",
  LblContractTypPeriod: "Contracttype periode",
  LblInactiveContractTypeGroupReason:
    "Reden voor het deactiveren van contracttype groep",
  LblPenaltyAmount: "Boetebedrag",
  LblPenaltyTimeInterval: "Boetetijdsinterval (minuten)",
  LblIsPenaltyEnabled: "Boete geactiveerd",
  LblJanuary: "Januari",
  LblFebruary: "Februari",
  LblMarch: "Maart",
  LblApril: "April",
  LblMay: "Mei",
  LblJune: "Juni",
  LblJuly: "Juli",
  LblAugust: "Augustus",
  LblSeptember: "September",
  LblOctober: "Oktober",
  LblNovember: "November",
  LblDecember: "December",
  LblSJan: "Jan",
  LblSFeb: "Feb",
  LblSMar: "Mar",
  LblSApr: "Apr",
  LblSMay: "Mei",
  LblSJun: "Jun",
  LblSJul: "Jul",
  LblSAug: "Aug",
  LblSSep: "Sep",
  LblSOct: "Okt",
  LblSNov: "Nov",
  LblSDec: "Dec",
  LblSunday: "Zondag",
  LblMonday: "Maandag",
  LblTuesday: "Dinsdag",
  LblWednesday: "Woensdag",
  LblThursday: "Donderdag",
  LblFriday: "Vrijdag",
  LblSaturday: "Zaterdag",
  LblSSu: "Zo",
  LblSMo: "Ma",
  LblSTu: "Di",
  LblSWe: "Wo",
  LblSTh: "Do",
  LblSFr: "Vr",
  LblSSa: "Za",
  LblForgotPassword: "Wachtwoord vergeten",
  LblChangePassword: "Wachtwoord wijzigen",
  LblOldPassword: "Oude wachtwoord",
  LblNewPassword: "Wachtwoord",
  LblProfileUpdatedSucessFully: "Profiel succesvol aangepast",
  LblPasswordChangedSucessFully: "Je wachtwoord is gewijzigd",
  LblUpdateProfile: "Profiel wijzigen",
  LbLReasonVehicle: "Reden onbeschikbaarheid",
  LblReasonDriver: "Reden blokkeren bestuurder",
  LblFrom: "Van",
  LblTo: "Tot",
  LblBooking: "Reservering",
  LblBookingRequest: "Reserveringsverzoek",
  LblOverview: "Reserveringsoverzicht",
  LblOverviewList: "Lijst met reserveringen",
  LblApproveBooking: "Reservering goedkeuring",
  LblApprove: "Goedkeuren",
  LblReject: "Afwijzen",
  LblNormal: "Nieuwe reservering",
  LblSpecial: "Speciale reservering",
  LblHistory: "Reserveringsgeschiedenis",
  LblBookingStatus: "Reserveringsstatus",
  LblBookingType: "Reserveringstype",
  LblAdminRemarks: "Opmerking Admin",
  LblBookingRemarks: "Reservering opmerkingen",
  LblDriverRemarks: "Opmerkingen bestuurder",
  LblBookingReferenceId: "Reserveringsnr.",
  LblAbort: "Afbreken",
  LblRevoke: "Intrekken",
  LblStatus: "Status",
  LblReference: "Referentienr.",
  LblRemarks: "Opmerkingen",
  LblSearchForVehicle: "Zoek voertuig",
  LblVehicleOverview: "Voertuigoverzicht",
  LblConfirmBooking: "Bevestig reservering",
  LblCurrentBookingDetail: "Details huidige reservering",
  LblCheckAvailability: "Controleer beschikbaarheid",
  LblBookingStartDateTime: "Start reservering",
  LblBookingEndDateTime: "Einde reservering",
  LblSource: "Ophaallocatie",
  LblRecurring: "Herhalend",
  LblRecurringId: "Herhalingreserveringsnr.",
  LblRecurringBookingReference: "Referentie herhalingsreserving",
  LblDaily: "Dagelijks",
  LblWeekly: "Wekelijks",
  LblMonthly: "Maandelijks",
  LblRecurrenceEndDate: "Einddatum herhaling",
  LblSearch: "Zoek",
  LblBookNow: "Reserveer",
  LblUpdateBooking: "Wijzig Reservering",
  LblEditCarNotAvailable: "Origineel geboekte auto is niet beschikbaar",
  LblSortBy: "Sorteer op",
  LblAvaibility: "Beschikbaarheid",
  LblNoMatchingVehicle: "Geen beschikbare voertuigen gevonden",
  LblAvailableSlots: "Beschikbare perioden",
  LblFeatures: "Kenmerken",
  LblDriverDetail: "Bestuurdersgegevens",
  LblBookingDetail: "Reserveringsgegevens",
  LblVehicleDetail: "Voertuiggegevens",
  LblBookingSuccess:
    "U heeft een boekingsaanvraag succesvol aangemaakt. Een kopie van het verzoek wordt verzonden naar het geregistreerde e-mailadres. Een kennisgeving wordt ook ter goedkeuring verzonden en u zult op de hoogte worden gesteld wanneer de boeking wordt geaccepteerd.",
  LblBookingUpdateSuccess:
    "Boeking succesvol bijgewerkt. Er wordt een melding verzonden naar het e-mailadres van de bestuurder.",
  LblBlockNormalBooking:
    "Je account is geblokkeerd. Neem contact op met de Administrator.",
  LblSingle: "Enkele",
  LblSeries: "Reeks",
  LblLicenceRequired1: "Gelieve het rijbewijsnummer te valideren, ga naar",
  LblLicenceRequired2: "Om de rijbewijsdetails bij te werken.",
  LblAcceptOrReject: "Goedkeuren / afwijzen",

  LblSpecialBooking: "Speciale reservering",
  LblAffectedBooking: "Betrokken reservering ",
  LblSpecialBookingType: "Speciale reservering type",
  LblSelectSpecialBookingType: "Selecteer speciaal reserveringtype",
  LblSpecialBookingConfiramtionmsg:
    "Weet je zeker dat je een speciale reservering wilt aanmaken?",
  LblEndDate: "Einde herhaling",
  LblNotification: "Melding",
  LblSubject: "Onderwerp",
  LblDate: "Datum",
  LblWelcomeNotification: "Welkom bij de meldingen inbox",
  LblTemplate: "Sjabloon",
  LblTemplateList: "Sjabloonlijst",
  LblTemplateName: "Sjabloonnaam",
  LblTemplateType: "Sjabloontype",
  LblIsEmailTemplate: "E-mail",
  LblIsWebTemplate: "Web",
  LblBody: "Carrosserie",
  LblNotificationEventManagement: "Melding gebeurtenis management",
  LblNotificationEvent: "Melding gebeurtenis",
  LblModuleName: "Modulenaam",
  LblSMS: "SMS",
  LblUserType: "Gebruikerstype",
  LblTimeBlock: "Tijdblok",
  LblTimeBlockName: "Tijdblok naam",
  LblTimeBlockWeekDays: "Tijdblok weekdagen",
  LblTimeBlockStartTime: "Tijdblok starttijd",
  LblTimeBlockEndTime: "Tijdblok eindtijd",
  LblTimeBlockStartDate: "Tijdblok startdatum",
  LblTimeBlockEndDate: "Tijdblok einddatum",
  LblServiceOffer: "Service-aanbod",
  LblServiceOfferList: "Service-aanbod lijst",
  LblServiceOfferName: "Servicenaam",
  LblServiceOfferType: "Servicetype",
  LblStandardTariff: "Standaardtarief",
  LblTimeUsedOrBooked: "Tijd gebruikt/gereserveerd",
  LblDistance: "Afstand",
  LblPenalty: "Boete",
  LblAdditional: "Extra",
  LblAdditionalAbbr: "Bovendien",
  LblUnit: "Eenheid",
  LblWegoAdmin: "WeGo beheerder",

  LblWegoAdmins: "Wego Admins",

  LblReSend: "Stuur opnieuw",
  LblResendActivationMail: "Activatiemail",
  LblResendActivationMailFailure: "Versturen van activatiemail niet gelukt",
  LblResendActivationMailSuccess: "Activatiemail verstuurd",

  LblSubscription: "Abonnement",
  LblSubscriptionName: "Abonnementnaam",
  LblTimeInterval: "Tijdsinterval",
  LblAmount: "Hoeveelheid",
  LblFreeKilometer: "Gratis credits",
  LblFreeMinute: "Gratis minuten",
  LblFreeHours: "Gratis uren",
  LblNumberOfSubscription: "Aantal abonnementen",
  LblUnsubscribe: "Opzeggen abonnement",
  LblsubscribeEndDate: "Einddatum abonnement",
  LblSubscriptionStartDate: "Startdatum abonnement",
  LblSpecialPeriod: "Speciale periode",
  LblspecialPeriodName: "Speciale periode naam",
  LblSpecialPeriodStartTime: "Speciale periode starttijd",
  LblSpecialPeriodEndTime: "Speciale periode eindtijd",
  LblSpecialPeriodWeekDays: "Speciale periode weekdagen",
  LblNormalPeriod: "Normale periode",

  LblSpecialPeriods: "Speciale Periode",
  LblWegoAdminDependencyValidation:
    "WeGo beheerder kan niet worden verwijderd omdat deze aan een andere entiteit is gekoppeld",

  LblBookingInvoice: "Reserveringsfactuur",
  LblInvoiceStatus: "Factuurstatus",
  LblAdminDependencyValidation:
    "Beheerdersrol kan niet worden verwijderd omdat deze aan een andere entiteit is gekoppeld.",
  LblAdminDependencyAlert: "Beheerdersafhankelijkheidswaarschuwing",
  LblTotalHours: "Totaaltijd",
  LblInvoiceType: "Factuurtype",
  LblSummary: "Summary",
  LblTotalKm: "Totaalafstand (km.)",
  LblTotalExpense: "Totale kosten",
  LblInvoiceNumber: "Factuurnummer",
  LblAdminDependencyValidationOnDelete:
    "Geselecteerde beheerder kan niet worden verwijderd omdat deze aan een andere entiteit is gekoppeld.",
  LblBegin: "Start",
  LblEnd: "Eind",
  LblVat: "BTW",
  LblTotal: "Totaal",
  LblInvoiceRequestDateTime: "Factuurverzoek datum/tijd",
  LblInvoiceSendDateTime: "Factuurverzend datum/tijd",
  LblInvoiceDateTime: "Factuur datum/tijd",
  LblInvoiceDetail: "Factuurdetails",
  LblResend: "Herzenden",
  LblDownload: "Download",
  LblResendInvoiceConfirm: "Weet u zeker dat u %0 wilt herzenden?",
  LblRemoveContactPersonConfirm:
    "Weet u zeker dat u de contactpersoon wilt verwijderen?",
  LblPenaltyRate: "Boetetarief",
  LblSendInvoiceConfirm: "Weet u zeker dat u de factuur wilt verzenden?",
  LblInvoicing: "Facturatie",
  LblLegacyInvoicing: "Factuur (voor 2025-04-22)",
  LblInvoices: "Factuur",
  LblCarwiseConfiguration: "Carwise-configuratie",
  LblCarwiseConnectionUrl: "Verbindings-URL",
  LblCarwiseConnectionUsername: "Verbindingsnaam",
  LblCarwiseEnable: "Carwise ingeschakeld",
  LblCarwiseConnectionPassword: "Verbindingswachtwoord",
  LblCarwiseAutoDeleteFrequencyInDays: "Automatische verwijderfrequentie (in dagen)",
  LblDamageImageExtentions: "Schadebestand formaat",
  LblDone: "Gereed",
  LblClear: "Clear",
  LblEditPage: "Bewerk %0",
  LblAddPage: "Voeg %0 toe",
  LblListPage: "%0 Overzicht",
  LblAll: "Alle",

  LblProfile: "Profiel",
  LblSignOut: "Log uit",
  LblTemplateNote1:
    "Verwijder of wijzig tekst geschreven als {variabelename} niet. Dit is een variabel element dat tijdens versturen wordt vervangen door de betreffende waarde uit de database.",
  LblTemplateNote2:
    "Wijzig a.u.b. niets aan de tabelstructuur. U kunt een nieuwe toevoegen, echter de bestaande dient niet gewijzigd te worden.",
  LblTemplateNote3:
    "Zorg er alstublieft voor dat wanneer u een 'placeholder' kopieert en deze in een HTML-editor wilt plakken, u deze als \"Plakken als gewone tekst\" plakt.",
  LblConfirmUnsubscribe: "Weet u zeker dat u zich wilt afmelden?",
  LblDriveHours: "Beschikbare uren",
  LblVehicleImage: "Voertuigafbeelding",
  LblMaintenance: "Onderhoud",
  LblUNAVAILABLE: "Onbeschikbaar",
  LblTestInvoiceGenerator: "Testfactuur generator",
  LblInvoicingDateTime: "Factuur datum/tijd (UTC)",
  LblGenerateInvoice: "Genereer factuur",
  LblDeleteAllSelectedRecords: "Verwijder alle geselecteerde regels",
  LblCancelAllSelectedRecords: "Annuleer alle geselecteerde regels",
  "LblExportAll(CSV)": "Exporteer (CSV)",
  LblContractTypeGroupAvailableForSubscription:
    "Geen contracttype groep beschikbaar om %0 toe te voegen.",
  LblAddContactPerson: "Voeg contactpersoon toe",
  LblRemoveContactPerson: "Verwijder contactpersoon",
  LblNote: "Notitie",
  LblCompletelyEndConfirm: "Rit volledig beindigen",
  LblEndTrip: "Beëindig rit",
  LblTestTrip: "Testrit",
  LblTripSimulator: "Ritsimulator",
  LblTestTripSuccess: "Testrit succesvol aangemaakt",
  LblDrivingStartDateTime: "Begin datum/tijd rijden",
  LblDrivingEndDateTime: "Eind datum/tijd rijden",
  LblInvoiceMoment: "Factuurtijdstip",
  LblExtend: "Verlengen",
  LblExtendRequire: "Voer a.u.b. de verlengingstijd in (minuten)",
  LblExtendInfoMsg: "U kunt boeking tot %0 minuten verlengen",
  LblExtendValidationMsg: "Deze reservering kan niet verlengd worden",
  LblExtendBooking: "Verleng Reservering",
  LblBookingExtendedSuccess: "Verlenging Resevering gelukt",
  LblOverExtendValidationMsg:
    "Reservering kan niet met meer dan %0 minuten verlengd worden",
  LblUnLock: "Ontgrendelen",
  LblLock: "Sluit",
  LblVehicleStatus: "Voertuig status",
  LblTripSuccess: "Rit opgeslagen",
  LblLockSuccessfully: "Voertuig succesvol gesloten",
  LblLockCompletelySuccessfully: "Voertuig afgesloten",
  LblUnLockSuccessfully: "Voertuig ontgrendeld",
  LblUnlockProblem: "Probleem tijdens ontgrendelcommando",
  LbllockProblem: "Probleem tijdens afsluitcommando",
  LblLockCarCompletely: "Sluit en beëindig de reservering",
  LblStartDateTime: "Start datum/tijd",
  LblEndDateTime: "Eind datum/tijd",
  LblBookingTripDetail: "Boeking rit details",
  LblAddNewTrip: "Voeg nieuwe rit toe",
  LblBookingExpenseDetail: "Details Reseveringsonkosten",
  LblUnlockErrorMessage:
    "Geen actieve contracttype groep beschikbaar bij deze reservingstijd",
  LblExpenseAmount: "Onkostenbedrag",
  LblExpenseName: "Onkostennaam",
  LblExpenseSuccess: "Onkosten succesvol opgeslagen",
  LblReceipt: "Ontvangst",
  LblHelpdeskNo: "Helpdesknummer",
  LblInactiveReason: "Reden voor inactiviteit",
  LblBookingExpired:
    "U kunt het voertuig niet ontgrendelen als de reservering is verlopen",
  LblTripCalculationInProgress:
    "Hopelijk heeft u een voorspoedige rit gehad! Het voertuig zal binnen een paar seconden sluiten.",
  LblActualInvoiceGenerationDate: "Datum factuurcreatie",
  LblAvailableForAllSlots: "Voertuig beschikbaar voor alle tijdslots",
  LblUnAvailableSlots: "Onbeschikbare tijdslots",
  LblNoOfDrivers: "Aantal bestuurders",
  LblVTSReqLogDetail: "VTS log details aanvraag",
  LblVTSReqDateTime: "Verzoek datum/tijd",
  LblVTSProcessTime: "Verwerkingstijd",
  LblVTSResTime: "Resultaat tijdstip",
  LblVTSReqType: "Verzoek type",
  LblVTSResult: "Resultaat",
  LblSVGDriversList: "Poolgroepbestuurders",
  LblVehicleInformation: "Voertuiginformatie",
  LblVTSVehicle: "VTS Voertuig",
  LblFleetId: "Vloot ID",
  LblContractId: "Contract ID",
  LblVIN: "VIN",
  LblVTSVehicleUpdateSuccess: "Voertuig succesvol %0",
  LblTroubleShootVTS: "VTS Probleemoplossing",
  LblVTSVehicleList: "VTS voertuig lijst",

  //Booking Type
  LblNORMALBOOKINGTYPE: 'NORMAAL',
  LblMAINTENANCEBOOKINGTYPE: 'ONDERHOUD',
  LblUNAVAILABLEBOOKINGTYPE: 'ONBESCHIKBAAR',

  //Booking Request Status
  LblAPPROVEDBOOKINGREQUEST: 'GOEDGEKEURD',
  LblREJECTEDBOOKINGREQUEST: 'AFGEKEURD',
  LblPENDINGBOOKINGREQUEST: 'INAFWACHTING',


  //Booking Status
  LblABORTED: 'AFGEBROKEN',
  LblCANCELLED: 'GEANNULEERD',
  LblCONFIRMED: 'BEVESTIGD',
  LblFINISHED: 'BEËINDIGD',
  LblNOSHOW: 'NOSHOW',
  LblPENDING: 'INAFWACHTING',
  LblREVOKED: 'INGETROKKEN',
  LblRUNNING: 'GESTART',
  LblREADYFORPAYMENT: 'KLAAR VOOR BETALING',

  //Invoice Status
  LblOPEN: 'OPEN',
  LblSENT: 'VERZONDEN',
  LblCLOSED: 'AFGESLOTEN',
  LblREQUESTFORPAYMENT: 'VERZOEK OM BETALING',
  LblREOPEN: 'HEROPEND',
  LblFileNotFound: "Het bestand bestaat niet, neem contact op met de helpdesk",

  // Error Log
  LblErrorLog: "Foutenlogboek",
  LblComponentName: "Componentnaam",
  LblLogType: "Log Type",
  LblEventDateTime: "Gebeurtenis datum/tijd",

  // Interface Status
  LblInterfaceStatus: "Interface Status",
  LblLastStatusChangeDateTime: "Laatste status wijziging datum/tijd",
  LblLastCarwisePollDateTime: "Last Carwise Poll DateTime",
  LblUpdatedDateTime: "Gewijzigde datum / tijd",
  LblMonitoring: "Monitoring",
  LblDropoffMessage: "Dropoff bericht",
  LblPreferredlanguage: "Voorkeurs taal",
  LblDebtornr: "Debiteurnummer",
  //ErrorEscalation
  LblDuplicateErrorEscalation: "Dubbele foutescalatieconfiguratie gevonden",
  LblErrorEscalation: "Foutescalatie",
  LblComponent: "Component",
  LblSelectAdminLevel: "Selecteer beheerdersniveau",
  LblWegoAdminLevel: "Wego Admin Level",
  LblCustomerAdminLevel: "Klantbeheerderniveau",
  LblInstanceAdminLevel: "Instantiebeheerderniveau",

  LblEnableLogin: "Login inschakelen",
  LblEnableErrorEscalation: "Schakel foutescalatie in",
  LblErrorEscalationMinutes: "Fout bij escalatie minuten",

  //Report Damage
  LblReportDamage: "Schade rapporteren",
  LblCompleteDamageReport: "Schaderapport indienen",
  LblDamageFile: "Schade bestand",
  LblDescribe: "Beschrijf de schade...",
  LblCause: "Beschrijf de oorzaak...",
  LblReportDamageMsg: "Schade gerapporteerd",
  LblSelectFile: "Selecteer bestand",

  // Import Data
  LblCSVImport: "CSV bestand importeren",
  LblValidateCSV: "Valideren CSV",
  LblImportValidPerson: "Importeren geldig Persoon",
  LblImportValidDriver: "Geldige bestuurder importeren",
  LblImportValidVehicle: "Geldig voertuig importeren",
  LblCSVType: "CSV bestandstype",
  LblCSVFile: "CSV bestand",
  LblRecordImportedSuccess: "%0 is geïmporteerd",
  LblInvalidReason: "Ongeldige Reden",
  LblSameVTSCommand:
    "Het verzoek wordt al verwerkt. Een moment geduld alstublieft.",
  LblImportPerson: "Persoon importeren",

  //Subscription related Changes
  LblSubscriptionInterval: "Abonnementsperiode",
  LblPaymentInterval: "Betalingsinterval",
  LblInvoicInterval: "Factuurinterval",
  LblInterval: "Interval",
  LblInvoiceMomentDay: "Factuur moment (dag van de week)",
  LblInvoiceMomentMonth: "Factuur moment (dag van de maand)",
  LblFreeMinuteInterval: "Gratis minuten interval",
  LblFreeKMInterval: "Gratis kilometers interval",
  LblSelectSubscriptionInterval: "Selecteer abonnementsperiode",
  LblSelectInvoiceInterval: "Selecteer factuurinterval",
  LblSelectPaymentInterval: "Selecteer betalingsinterval",
  LblSelectFreeKMInterval: "Selecteer gratis kilometerinterval",
  LblSelectFreeMinInterval: "Selecteer gratis minuteninterval",
  LblYearlySub: "Jaarlijks",
  LblMonthlySub: "Maandelijks",
  LblWeeklySub: "Wekelijks",
  LblFreePerWeek: "Per week",
  LblFreePerMonth: "Per maand",
  LblFreePerTriMonth: "Per 3 maanden",
  LblFreePerBiannual: "Per 6 maanden",
  LblFreePerYear: "Per jaar",
  LblDefaultContractTypeGroup: "Standaard contractype groep",
  LblSelectDefaultContractTypeGroup: "Selecteer standaard contracttype groep",
  LblSendInvoiceToDriver: "Factuur verzenden naar bestuurder",
  LblInherit: "Neem over",

  //Invoice Moment
  LblDayOfMonth: "Dag van de maand",
  LblDayOfWeek: "Dag van de week",
  LblSelectDayOfWeek: "Selecteer dag van de week",
  LblInstanceLogo: "Instantie Logo",
  LblResetPasswordFailure:
    "Het wachtwoord kan niet worden gereset, want de gebruiker is nog niet geactiveerd.",
  LblInvoiceDeleteValidation:
    "Kan factuur niet verwijderen vanwege associatie met andere entiteit",
  //Additional Free Item
  LblAdditionalFreeItems: "Extra gratis credits",
  LblDateAwared: "Toekenningsdatum",

  LblAdditionalFreeItemsMenu: "Extra gratis credits",

  LblTotalFreeKilometer: "Totaal gratis kilometers",
  LblTotalFreeMinute: "Totaal gratis minuten",
  LblCurRemainFreeKilometer: "Resterende gratis kilometers",
  LblPrevRemainFreeKilometer: "Vorige hoeveelheid resterende gratis kilometers",
  LblCurRemainFreeMinute: "Resterende gratis minuten",
  LblPrevRemainFreeMinute: "Vorige hoeveelheid resterende gratis minuten",
  LblPrevious: "Vorige",
  LblCurrent: "Huidig",

  //Instance Clone
  LblInstanceClone: "Instantie klonen",
  LblNewInstanceName: "Naam nieuwe instantie",
  LblCloneResult: "Resultaat klonen",
  LblCloneStatus: "Kloon Status",
  CloneError:
    "Er is een fout opgetreden bij het klonen van de instantie en de bijbehorende entiteiten.",

  //SubscriptionAvailabilityRestriction
  LblSubscriptionAvailabilityRestriction:
    "Beperking beschikbaarheid abonnement",
  LblStartDay: "Begindag",
  LblEndDay: "Einddag",
  LblStartTime: "Starttijd (hh:mm)",
  LblEndTime: "Eindtijd (hh:mm)",
  LblRestriction: "Beperking",

  //Trip Detail Report
  LblTripDetailReport: "Rit overzicht",
  LblTripDetailList: "Gedetailleerd reserveringsoverzicht",
  LblSearchTripforDriver: "Zoek ritten voor bestuurder",
  LblExportReport: "Exporteer rapport",
  LblValidateLiceanceNumberMessage: "Controleer je rijbewijs",
  LblBookingIntervalRate: "Intervaltarief",
  LblPerHour: "Per uur",
  LblPerBookingIntarval: "Per reserveringsinterval",
  LblTimeRate: "Tijdtarief",
  LblToalBookingDuration: "Reserveringsduur",

  LblTripComments: "Rit opmerking",
  LblTripCommentDescription: "Voer opmerking in",
  LblTripCommentError: "Voer a.u.b. opmerking in",
  LblShowTripComment: "Bekijk opmerking",
  LblAddTripComment: "Voeg opmerking toe",
  LblTripCommentBy: "Rit opmerking door",
  LblTripCommentOn: "Rit opmerking op",

  LblCleanRequire: "Schoonmaak benodigd",
  LblFualRequire: "Brandstof benodigd",
  LblVehicleDamageList: "Lijst van voertuigschades",
  LblDamageCause: "Schadeoorzaak",
  LblDamageReportedBy: "Gemeld door",
  LblDamageReportedOn: "Gemeld op",
  LblConfirmResolveDamage:
    "Weet u zeker dat u de schademelding wilt verwijderen?",
  LblVehicleDamgeResolveSuccess: "Schademelding verwijderd",
  LblDamageDesc: "Schade omschrijving",
  LblFutureBooking: "Toekomstige reserveringen",
  LblVehFutureBookingList: "Lijst met toekomstige voertuigboekingen",
  LblResolveDamge: "Schademelding verwijderen",
  LblReserved: "Gereserveerd",
  LblVehicleInfoSuccess: "Voertuiginformatie opgeslagen",
  LblInformation: "Informatie",
  LblVtsServiceStatus: "VTS service status",
  LblVtsLicencetag: "VTS kenteken",
  LblVtsDoorStatus: "Status portier",
  LblVtsIssueCommand: "Stuur commando",
  LblVehicleLocation: "Voertuiglocatie",
  LblEventHistory: "VTS gebeurtenis geschiedenis",
  LblVehicleObuStatus: "Status Voertuig OBU",
  LblVTSHistory: "VTS gebeurtenis geschiedenis",
  LblRequestType: "Opdracht Type",
  LblCommandInitiator: "Opdracht verstuurd door",
  LblResult: "Resultaat",
  LblVTSRequestTime: "VTS aanvraag tijd",
  LblVTSResultTime: "VTS Resultaat tijd",
  LblWegoProcessTime: "WeGo verwerkingsduur",
  LblWegoRequestTime: "WeGo aanvraag tijd",
  LblWegoResultTime: "WeGo resultaat tijd",
  LblView: "Overzicht",
  LblVehicleNotInitialized: "Voertuig niet geïnitialiseerd",
  LblLastReceivedTime: "Tijd laatst ontvangen bericht",

  LblFreePerBookingInterval: "Per reserveringsinterval",
  LblVtsLocation: "VTS locatie",
  LblSelectObuType: "Selecteer OBU Type",
  LblObuType: "OBU Type",
  LblDeviceId: "Device Id",
  LblClaimCode: "Claim code",

  LblRetriveAddress: "Adres ophalen",
  LblCrearedDate: "Datum gemaakt",
  LblCreatedBy: "Gemaakt door",
  LblPerBooking: "Perreservering",
  LblSelectFilter: "Selecteer filter",
  LblAuditEntries: "Controleer invoer",
  LblFilter: "Filter",
  LblCategory: "Categorie",
  LblEventName: "Gebeurtenis naam",
  LblEventData: "Gebeurtenis gegevens",
  LblMoment: "Moment",
  LblUser: "Gebruiker",
  LblNoEventDataFound: "Geen eventgegevens gevonden",
  LblEventViewer: "Gebeurtenis bekijken",
  LblOBU: "OBU",
  LblClone: "Kopieer",
  LblCloneVehicle: "Kopieer %0",
  LblFualNotRequire: "Brandstof niet benodigd",
  LblCleanNotRequire: "Schoonmaak niet benodigd",
  LblSubscriptionInfo: "Abonnementsinformatie",
  LblVehiclDamaged: "Voertuig met schade",
  LblVehicleNotDamaged: "Voertuig zonder schade",
  LblDamage: "Schade",
  LblFreeBooking: "Aanpassen reserveringskosten",
  LblBookingCustomFee: "Totale reserveringskosten",
  LblFreeBookingSuccess: "Reserveringskosten opgeslagen",
  LblEnterLocation: "Voer locatie in",
  LblHomeLocation: "Thuislocatie",
  LblLocationMode: "Locatieinstelling",
  LblMeter: "Meter",
  LblLocation: "Locatie",
  LblPickupLocation: "Ophaallocatie",
  LblLocationUnavailable: "Locatie onbeschikbaar",
  LblAvailabilityCalander: "Beschikbaarheidskalender",
  LblAvailableOn: "Beschikbaar op",
  LblGeofenceEnabled: "Geofence actief",
  LblLocationNotFound: "Kan adres niet te bepalen",
  LblAddressNotAvailable: "Kan adres niet te bepalen op deze locatie",

  LblReports: "Rapporten",
  LblDrivers: "Bestuurders",
  LblTemplates: "Sjablonen",
  LblPlaceHolder: "Placeholder",
  LblSampleTemplate: "Voorbeeld sjabloon",
  LblLatexFileDownloadValidation: "Ongeldige Latex inhoud",
  LblLocationDataExchangeNotAssign:
    "Dit voertuig kan niet geboekt worden als er geen VTS-voertuig is toegewezen. Wil je verder gaan ?",
  LblRevenue: "Omzet",

  // Vehicle Occupancy Report
  LblVehicleOccupancyReport: "Bezettingsgraadrapport",
  LblReservedTime: "Gereserveerde tijd",
  LblUsageTime: "Gebruiksduur",
  LblUsageTimeAtOffice: "Gebruik tijdens kantooruren",
  LblUsageTimeoutOffice: "Gebruik buiten kantooruren",

  LblRevenuePerVehicleReport: "Omzet per voertuig",
  LblSearchRevenuePerVehicle: "Zoek omzet per voertuig",
  LblRevenuePerVehicleList: "Lijst van omzet per voertuig",
  lblThreshold: "Vooraf waarschuwen vanaf",

  //OdometerLogTrail
  LblOdometerLogTrail: "Kilometerteller historie",
  LblUserProvidedOdometerValueInKmr: "Kilometerstand (km)",
  LblDescriptionOfDeviation: "Verklaring voor afwijking",
  LblFromOdometer: "Van kilometerteller",
  LblToOdometer: "Naar kilometerteller",
  LblAddDescriptionOfDeviation: "Voeg verklaring voor afwijking toe",
  LblDeviation: "Afwijking (km)",
  LblLastOdometerValue: "Vorige kilometerstand (km)",
  LblLastOdometerDT: "Vorige odometer datum",

  LblodometerConfiguration: "Instellingen kilometerteller",
  LblEnableOnApp: "Toon in app",
  LblWarningPer: "Waarschuwing (%)",

  LblOdometerRegistered: "Kilometerstand geregistreerd",
  LbLOdometerEnabled: "Kilometerteller aan",
  LblOdometerValue: "Kilometerstand",
  LblMaintenancePlanningList: "Onderhoudsplanning",
  LblSearchMaintenancePlanningValue: "Zoek in onderhoudsplanning",
  LblMaintenancePlanningreport: "Onderhoudsplanning rapport",
  LblShowDeviation: "Toon afwijking zonder verklaring",

  LblTitle: "Titel",
  LblFooterText: "Voetnoot",
  LblvalidEmailDomain: "Alleen e-mailadressen van dit domein toegestaan",
  LblURLSettings: "URL instellingen",
  LblSuccessUrl: "URL instellen gelukt",
  LblEmailSettings: "E-mail instellingen",
  LblSendActivationEmail: "Stuur automatische activatiemails",
  LblSendConfirmationEmail: "Stuur automatische bevestigingsmails",
  LblRequireAdminApprovel:
    "Verplicht toestemming van beheerder bij nieuwe inschrijving",
  LblDriverInformationToBeInclude:
    "Bestuurdersinformatie welke moet worden toegevoegd",
  LblSignUpForm: "Aanmeldformulier",
  LblSignupForms: "Aanmeldformulieren",
  LblSignupFormsOverview: "Overzicht aanmeldformulieren",
  LblWhoCanApprove: "Wie kan nieuwe aanmeldingen toestaan?",
  LblSignupFormLogo: "Logo aanmeldformulier",
  LblChooseSubscription: "Kies de abonnementen voor op het aanmeldformulier",
  LblSignupParameter: "Webpagina aanmeldformulier",
  LblSignupParameterText: "Aanmeldformulier URL-tekst",
  DomainNameString:
    "Door komma's gescheiden domeinnamen (zoals gmail.com,yahoo.com)",
  SignupParameterString: "Alleen letter, cijfers en - zijn toegestaan",

  LblAvailability: "Beschikbaarheid",
  LblSettings: "Instellingen",
  LblCurrentStatus: "Huidige status",
  LblFlags: "Flags",
  LblNA: "Niet beschikbaar",

  //Sign up form
  LblConfirmEmail: "Bevestig e-mailadres",
  LblSignup: "Aanmelden",

  LblSignupsOverView: "Aanmeldoverzicht",
  LblSignupApproval: "Toestemming aanmeldingen",
  LblAccept: "Accepteer",
  LblSignupFormDescription: "Aanmeldformulier omschrijving",

  LblCurrentOdometerValue: "Huidige kilometerstand",
  LblCurrentOdometerDateTime: "Tijdstip huidige km stand",

  LblCreateDirectDebitFile: "Maak incassobestand aan",
  LblCheckEmptyIbanNumber: "Controleer IBAN nummers",
  LblCreatedDate: "Datum gecreëerd",
  LblIncludeInDirectDebit: "Aan incassobestand toevoegen",
  LblDirectDebitFileDate: "Datum incassobestand",
  LblDirectDebitConfiguration: "Incasso configuratie",
  LbLDirectDebitEnabled: "Incasso functionaliteit inschakelen",
  LblDirectDebitEnableper: "Incasso functionaliteit ingeschakeld vanaf",
  LbLCreditorDetails: "Crediteur informatie",
  LblAddress: "Adres",
  LblIBANNumber: "IBAN",
  LblCountryCode: "Landcode",
  LbLBillingInformation: "Betaalgegevens",

  LblInvoicingDetails: "Factuurgegevens",
  LbLSubjectToDirectDebit: "Gebruikt automatische incasso?",

  //Batch Upload Person
  LblBatchUploadPersonSetting: "Import Personen instellingen",
  LblShowBatchUploadInfo: "Batch invoer voor personen functionaliteit inschakelen?",
  LblAllowBatchUpload: "Rol die mag importeren",
  LblAllowActivationMail: "Gebruik activatiemails",
  LblGenerateRandomPassword: "Systeem genereert wachtwoorden",
  LblUserUploadPassword: "Wachtwoord in importbestand",
  LblFieldToUploadedOrValidated: "Aangeleverde velden",
  LblBatchUploadPerson: "Importeer Personen",
  LblBatchUpload: "Importeer Personen",
  LblDownloadTemplate: "Importbestand voorbeeld",
  LblUserAssignSVGMessage: "Gebruiker nog niet toegewezen aan poolgroep!",
  LblInvalidRecordReason: "Ongeldig(e) record(s)",
  LblSelectedSVGs: "Geselecteerde poolgroep(en)",

  LblDashboardConfiguration: "Dashboard Configuratie",
  LblEnableCurrentLocation: "Zet 'Huidige locatie' aan",
  LblDefaultLocation: "Standaard te tonen locatie",
  LblEnableAutoUpdate: "Zet automatisch verversen aan",
  LblPriorityNotificationSetting: "Voertuigstatusmelding instellingen",
  SelectionRequiredMsg:
    "Selecteer ten minste één boeking om goed te keuren / af te wijzen",
  LblSelectionRequired: "Selectie vereist",
  LblCollectionDate: "Incassodatum",
  LblBICCode: "BIC code",
  LblDirectDebitFile: "Incasso Bestand",
  LblFormat: "Formaat",
  LblMissingIBANNumber: "Ontbrekende IBAN",
  LblImportDriverRole: "Bestuurdersrol automatisch toewijzen?",
  LblAssignToSVG: "Toewijzen aan poolgroep(en)",
  LblSVG: "Poolgroep",
  LblMandateId: "Mandaat Id",
  LblMandateSignatureDate: "Datum handtekening mandaat",
  LblIsAmmandment: "Is Ammandement",
  LblRemovePersonDetails: "Verwijder persoonsgegevens",

  LblDashboard: "Dashboard",
  LblGroupAdmin: "Groepsbeheerder",
  LblCurrentLocation: "Huidige locatie",
  LblCurrentDriver: "Huidige bestuurder",
  LblNextDriver: "Volgende bestuurder",
  LblSecond: "Second(en)",

  LblCleaning: "Schoonmaken",
  LblRefueling: "Tanken/opladen",
  LblAPKMaintenance: "APK onderhoud",
  LblOutsideGeofence: "Buiten geofence",
  LblNotBooked: "Niet geboekt",
  LblNotBookedSince: "Niet geboekt sinds",
  LblLowBattery: "Lage accuspanning",
  LblBatteryVolt: "V.",
  LblLowCharge: "Batterij (bijna) leeg",
  LblChargingPercentage: "%",
  LblOnSamePosition: "Niet verplaatst",
  LblLastPosition: "Laatste positie",
  LblNotReturn: "Niet Retour",
  LblCommunicationProblem: "Communicatie probleem",
  LblInuse: "In gebruik",
  LblPriority: "Prioriteit",
  LblDirectDebitDownloadSuccess: "Incassobestand gedownload",
  LblDefaultStatus: "Default Status",
  LblWarnings: "Waarschuwingen",
  LblDirectDebitFileId: "Incassobestand Id",
  LblTotalAmount: "Totaalbedrag",
  LblReCreate: "Download opnieuw",
  LblPleaseEnterCollectionDate: "Voer incassodatum in",
  LblOpenViaLowLevel: "Low level ontgrendeld",
  LblInstanceNotificationNote1: "Instelling werkt als instelling bij bedrijf",
  LblNoInvoiceSelected: "Geen facturen geselecteerd voor incasso",
  LblIBANNumberRequired: "Voer IBAN en BIC Code in",
  LblNoEmptyIBANFound: "Geen lege IBAN gevonden",

  LblInvalidTagUsed: "Ongeldige tag gebruikt",
  LblNotInvalidTagUsed: "Geen ongeldige tag gebruikt",

  LblShowVehicleChargeLevel: "Toon voertuig laadniveau in web- en App?",
  LblChargeLevel: "Laadniveau",
  LblCharging: "Opladen",
  LblNoDataFound: "Geen data beschikbaar",
  LblOfficeStartTime: "Start kantooruren (hh:mm)",
  LblOfficeEndTime: "Einde kantooruren (hh:mm)",
  //Reports
  LblTripDataReport: "Ritdata overzicht",
  LblByDriver: "Op bestuurder",
  LblByVehicle: "Op voertuig",
  LblModuleRights: "Module rechten",
  LblCostCenterReport: "Kostenplaatsrapport",
  LblShowTotalOnly: "Toon alleen totaal",
  LblByOrganization: "Op organisatie",

  //Organization
  LblOrganization: "Organisatie",
  LblOrganizationName: "Organisatienaam",
  LblOrganizationAddress: "Organisatieadres",
  LblExistingDriverAddSuccessMsg:
    "De bestuurder is succesvol toegevoegd en gekoppeld met de organisatie",
  LblAddDriverSuccessMsg: "Bestuurder toegevoegd en activerings link aan de bestuurder is succesvol verzonden.",
  LblCreateOrganization: "Creeer organisatie",
  LblOrganizationDriversList: "Organisatie Bestuurder",
  LblAddDriverToOrganization: "Bestuurder toevoegen aan organisatie",
  LblAddDriver: "Bestuurder toevoegen",
  LblVatNumber: "BTW-nummer",
  // Branding
  LblBranding: "Branding",
  LblLogo: "Logo's",
  LblEmailNotificationInvoiceTemplate: "E-mail melding & factuursjablonen",
  LblExpandedWebMenu: "Uitgeklapt web menu",
  LblCollapsedWebMenu: "Ingeklapt web menu",
  LblMobileApp: "Mobiele app",
  LblSplashScreen: "Opstartscherm",
  LblWebApplication: "Web applicatie",
  LblMobileApplication: "Mobiele applicatie",
  LblBrandingSavedSuccess: "Branding opgeslagen",
  LblBrandingTemplateConfiguration: "Branding & sjabloon configuratie",
  LblAppWebUI: "App & Web UI",
  LblNonBookingCommunication: "Algemene communicatie",
  LblApprovalAdminName: "Goedkeuring door beheerder",
  LblBookingCommunication: "Communicatie m.b.t. reservering",
  LblInstanceBranding: "Gebruik altijd instantie branding",
  LblCompanyBranding: "Gebruik bedrijfsbranding indien mogelijk",
  BO_TOP_MENU_ACTIVE_ITEM_BACKGROUND: "Top bar, menu and actieve items",
  BO_TOP_MENU_ACTIVE_ITEM_TEXT: "Menu tekst",
  BO_HIGHLIGHTED_BUTTON_BACKGROUND: "Gemarkeerde knop",
  BO_HIGHLIGHTED_BUTTON_TEXT: "Gemarkeerde knop tekst",
  BO_HIGHLIGHTED_BUTTON_BACKGROUND_HOVER: "Gemarkeerde knop (hover)",
  BO_HIGHLIGHTED_BUTTON_TEXT_HOVER: "Gemarkeerde knop tekst (hover)",
  BO_PRIMARY_BUTTON_BACKGROUND: "Primaire knop",
  BO_PRIMARY_BUTTON_TEXT: "Primaire knop tekst",
  BO_PRIMARY_BUTTON_BACKGROUND_HOVER: "Primaire knop (hover)",
  BO_PRIMARY_BUTTON_TEXT_HOVER: "Primaire knop tekst(hover)",
  BO_SECONDARY_BUTTON_BACKGROUND: "Secundaire knop",
  BO_SECONDARY_BUTTON_TEXT: "Secundaire knop tekst",
  BO_SECONDARY_BUTTON_BACKGROUND_HOVER: "Secundaire knop (hover)",
  BO_SECONDARY_BUTTON_TEXT_HOVER: "Secundaire knop tekst (hover)",
  BO_HYPERLINK_TEXT: "Hyperlink tekst",
  BO_HIGHLIGHT_BACKGROUND: "Markeer kleur",
  BO_HIGHLIGHT_TEXT: "Markeer tekst",
  BO_CALENDAR_EVENT_BACKGROUND: "Kalender item",
  BO_CALENDAR_EVENT_TEXT: "Kalender item tekst",
  MO_TOP_MENU_ACTIVE_ITEM_BACKGROUND: "Top bar en menu",
  MO_LOGO_AREA_BACKGROUND: "Logo achtergrond",
  MO_PAGE_BACKGROUND: "Achtergrond",
  MO_MENU_TEXT: "Menu tekst",
  MO_TITLE_TEXT: "Titel tekst",
  MO_HYPERLINK_TEXT: "Hyperlink tekst",
  MO_ENABLED_BUTTON_BACKGROUND: "Bruikbare knop",
  MO_ENABLED_BUTTON_TEXT: "Bruikbare knop tekst",
  MO_ENABLED_BUTTON_BACKGROUND_ACTIVE: "Bruikbare knop (actief)",
  MO_ENABLED_BUTTON_TEXT_ACTIVE: "Bruikbare knop tekst (actief)",
  MO_DISABLED_BUTTON_BACKGROUND: "Onbruikbare knop",
  MO_DISABLED_BUTTON_TEXT: "Onbruikbare knop tekst",
  MO_DISABLED_BUTTON_BACKGROUND_ACTIVE: "Onbruikbare knop (actief)",
  MO_DISABLED_BUTTON_TEXT_ACTIVE: "Onbruikbare knop tekst (actief)",
  MO_HIGHLIGHT_BACKGROUND: "Highlight kleur",
  MO_HIGHLIGHT_TEXT: "Highlight tekst",
  MO_CALENDAR_EVENT_BACKGROUND: "Kalender item",
  MO_CALENDAR_EVENT_TEXT: "Kalender item tekst",
  LblBookingDelayConfig: "Configuratie vertraging reservering",
  LblBookingDelayConfigEnabled: "Stuur e-mail naar beheerder",
  LblEnableSnauilTrail: "Activeer Snail Trail",
  LblAppSupportTo: "App Support Aan",
  LblNotificationInterval: "Meldingsinterval",
  LblNotifyAfterMinutes: 'Melding na "X" minuten',
  LblMinutes: "Minuten",
  lblNotificationRecipients: "Meldingsontvangers",
  LbLEnableBookingStillRunning:
    "Activeer notificatie 'Reservering niet afgesloten'",
  LblBookingrunningNotification:
    "Configuratie notificatie Reservering niet afgesloten",
  //Raise and clear settings for low battery flag
  LblDefaultVehicleSetting: "Standaard voertuiginstelling",
  LblLowBatteryFlagRaised: "Lage batterij waarschuwing op (spanning)",
  LblLowBatteryFlagClear: "Lage batterij waarschuwing gewist bij (spanning)",
  LblPreferableImageSize: "Voorkeursformaat afbeelding",
  LblWebBrandingExapandImageSize: "1150px X 260px",
  LblMobileBrandingImageSize: "550px X 250px",
  LblWebBrandingCollapseImageSize: "325px X 250px",

  LblMinutesAfterBookingEndTime: "Hoeveel minuten na reserveringseindtijd?",
  LblResendNotoficationEvery: "Herzend notificatie elke minu(u)t(en)",
  LblByBooking: "Op reservering",
  LblSnailTrailReport: "Snail Trail rapport",
  LblKickbackReport: "Kickback Report",
  LblGroupBy: "Groepeer bij",
  LblTripDetail: "Ritdetails",
  LblTripNumber: "Trip nummer",
  LblStart: "Start",
  LblAverageSpeed: "Gem. snelheid",
  LblSegmentDetail: "Segment detail",
  LblSegmentNumber: "Segmentnummer",
  LblSpeed: "Snelheid",
  LblOdometer: "Kilometerteller",
  LblNext: "Volgende",
  LblSegmentDetailNotAvailable: "Segment detail niet beschikbaar",
  LblUnitPerKm: "per km.",
  LblUnitPerBooking: "p/res.",

  LblBookingCostSummary: "Kostenoverzicht reservering",
  LblTimeCost: "Tijdkosten",
  LblTotalTime: "Totale tijd",
  LblTime: "Tijd",
  LblCostRateUnits: "Kosten (Hoeveelheid * Aantal)",
  LblFreeTime: "Gratis extra tijd",
  LblRate: "Tarief",
  LblExVat: "Ex. BTW",
  LblInclVat: "Incl. BTW",
  LblKmDriven: "Kms gereden",
  LblFreeKms: "Gratis credits",
  LblTimePercent: "Tijdpercentage",
  LblTotalExVat: "Totaal ex. BTW",
  LblTotalVat: "Totaal BTW",
  LblTotalInclVat: "Totaal incl. BTW",
  LblKilometerCost: "Kilometerkosten",
  LblBookingApprovedSuccessMsg:
    "Geselecteerde reserveringsaanvragen succesvol goedgekeurd",
  LblBookingRejectedSuccessMsg: "Geselecteerde reserveringssaanvraag afgewezen",
  LblRejection: "Afwijzing",
  LblrejectionReasonMsg:
    "Geef een reden voor de afwijzing van geselecteerde boekingsaanvragen",
  LblApproveConfirmationMsg:
    "Weet u zeker dat u alle geselecteerde boekingsaanvragen wilt goedkeuren?",
  LblFixedCost: "Vaste Kosten",
  LblTotals: "Totalen",
  LblTypeDamage: "Schade",
  LblTypeMaintenance: "APK onderhoud binnenkort",
  LblTypeOnSamePosition: "Voertuig meer dan %0 %1 op dezelfde locatie",
  LblTypeNotBooked: "Voertuig meer dan %0 %1 niet geboekt",
  LblTypeNotReturn:
    "Reservering eindtijd bereikt, voertuig niet op huislocatie",
  LblBatteryVoltage: "Batterij voltage",
  LblApprovedRejectedby: "Goedgekeurd / afgewezen door",
  LblBookingRequestList: "Reserveringsaanvraaglijst",

  LblCannotUnsubscribe:
    "Kan niet uitschrijven omdat de bestuurder een actieve reservering heeft",
  LblPer: "Per",

  LblDateRegistered: "Registratiedatum",
  LblRegisteredBy: "Geregistreerd door",
  LblKMPerHour: "Km/h",
  LblMeters: "Meters",
  LblSubscriptionEndOnBookingEnd:
    "Nog lopende reservering. Dit abonnement zal beeindigd worden wanneer reservering is voltooid.",
  LblMarkedForDeletion: "Geselecteerd voor verwijdering",
  LblApplyDateFilter: "Datum van toepassing",

  LblNoRestriction: "GEEN_BEPERKING",
  LblCustomAppTestApp: "CUSTOM_APP_EN_TEST_APP",
  LblCustomAppOnly: "CUSTOM_APP_ALLEEN",

  //Customer
  LblCustomer: "Klant",
  LblCustomerName: "Klantnaam",

  //Role Page
  LblRoleManagement: "Rol",
  LblRoleName: "Rolnaam",
  LblEntityName: "Entiteit Naam",
  LblRoleType: "Roltype",
  LblRoleAvailability: "Klant rol beschikbaarheid",
  LblInternalRoleName: "Interne Rol Naam",
  LblPresentationName: "Presentatienaam",
  LblDefaultRole: "Standaard rol",
  LblCustomRole: "Klantrol",
  LblAddRole: "Voeg Rol toe",
  LblEntity: "Entiteit",
  LblCopy: "Kopieer",
  LblAccessibilityMatrix: "Toegangsmatrix",
  LblDefaultRoleModifyWarning:
    "Aanpassen van de standaard rechten beïnvloedt alle gebruikers met de Standaard Rol.",
  LblCopyAccessibilityMatrix: "Kopieer Toegangsmatrix",
  LblAccess: "Toegang",
  LblCustomerAdmin: "Klantbeheerder",
  LblAdmin: "Beheerder",
  LblDoYouWantToRemove: "Wilt u %0 verwijderen als %1?",
  LblDoYouWantToAdd: "Wilt u %0 toevoegen als %1?",
  LblRoleAddedSuccess: "%0 als %1 toegevoegd",
  LblRoleDeletedSuccess: "%0 verwijderd als %1",
  LblInstanceAdmin: "Instantiebeheerder",
  LblInvitationMailSuccess:
    "Uitnodigingsmail is aan opgegeven e-mailadres verzonden",
  LblInvite: "Stuur uitnodiging",
  LblCreateNew: "Nieuw",
  LblCommonErrorMessage:
    "Een fout is opgetreden tijdens het verwerken van het verzoek. Neem contact met de beheerder.",
  LblError: "Fout",
  LblThankYouForAcceptingInvitation:
    "Dank voor het accepteren van de uitnodiging",
  LblPleaseClick: "Alstublieft klikken",
  LblHere: "hier",
  LblToLogin: "om in te loggen",
  LblThankYouForConfirmation: "Dank voor uw bevestiging",
  LblGoToHome: "ga naar Home",
  LblInvitationSuccess: "Uitnodiging succesvol",
  LblInvitationReject: "Uuitnodiging geweigerd",

  //
  LblAssignExisting: "Bestaande toewijzen",
  LblPersonProfileSuccessMessage: "Je profiel is succesvol geactiveerd",
  LblPlease: "Alstublieft",
  LblLogin: "Login",

  //Branding & Template
  LblBrandingandTemplates: "Branding & sjablonen",
  LblTermsAndCondition: "Algemene voorwaarden",
  LblTermsAndConditionList: "Algemene voorwaarden- en privacyverklaringlijst",
  LblName: "Naam",
  LblVersion: "Versie",
  LblActivityLog: "Activiteiten logboek",
  LblAcceptance1: "Vóór accountactivering",
  LblAcceptanceMoment: "Acceptatie moment",
  LblContents: "Inhoud",
  LblIsAccept: "Ik aanvaard",
  LblReadAndAgree: "Ik heb het gelezen en ga hiermee akkoord",
  LblClose: "Sluiten",
  LblTermsConditionPrivacy: "Algemene voorwaarden en privacyverklaring",
  LblPrivacyStatements: "Privacyverklaringen",

  //Pre Post Trip Setting
  LblPrePostTripSetting: "Begin en einde reis vragen instelling",
  LblPrePostTripQuestions: "Vragen voor en na de reis",
  LblPrePostTripQuestion: "Vraag voor en na de reis",
  LblPrePostTripQuestionList: "Vragenlijst begin en eind reis",
  LblPreTripQuestion: "Vragen aan het begin van de reis",
  LblCustom: "Aangepast",
  LblPostTripQuestion: "Vragen na de reis",
  LblRequired: "Verplicht",
  LblBeforeOpeningTheVehicle: "Voordat u het voertuig opent",
  LblAfterOpeningTheVehicle: "Na het openen van het voertuig",
  LblOrder: "Volgorde",
  LblQuestion: "Vraag",
  LblOn: "Aan",
  LblOptional: "Optioneel",
  LblOff: "Uit",
  LblAnswerType: "Antwoordtype",
  LblText: "Tekst",
  LblYesNo: "Ja/nee",
  LblAnswer: "Antwoord",
  LblTimeStamp: "Tijdstip",
  LblFazTripQuestion: "FaZ vragen",
  LblFazTripQuestionAfterClosingTheVehicle: "FaZ vragen na het sluiten van het voertuig",

  //Accessibility Matrix
  LG_WEB_DASHBOARD: "Web Dashboard",
  PR_BOOKING_REQUEST: "Boekingsaanvraag",
  LblApproveBookingRequest: "Goedkeuren",
  LblRejectBookingRequest: "Afkeuren",
  PR_DASHBOARD: "Dashboard",

  PR_REMOVE_DRIVER_LICENSE: "Remove Driver License",
  PR_VEHICLE_FUTURE_BOOKINGS: "Toekomstige boekingen voertuig",

  PR_INSTANCE: "Instance",
  PR_BRANDING: "Branding",
  PR_PERSON_OVERVIEW: "Person Overview",
  PR_WEGO_ADMINS: "Wego Admins",
  PR_COMPANY_OVERVIEW: "Company Overview",
  PR_CONTACT_PERSON: "Contact Person",
  PR_COMPANY_ADMIN: "Bedrijfsbeheerder",
  PR_COMPANY_VEHICLE_OVERVIEW: "Bedrijfswagenoverzicht",
  PR_COMPANY_SVG_OVERVIEW: "Bedrijfspoolgroepoverzicht",
  PR_ORGANIZATION_OVERVIEW: "Organization Overview",
  PR_ORGANIZATION_CONTACT_PERSON: "Organization Contact Person",
  PR_ORGANIZATION_ADMIN_OVERVIEW: "Organisatie beheerdersoverzicht",
  PR_ORGANIZATION_DRIVER_OVERVIEW: "Organisatie bestuurdersoverzicht",
  PR_SHARED_VEHICLE_GROUP_OVERVIEW: "Poolgroep overzicht",
  PR_SHARED_VEHICLE_GROUP_ADMIN_OVERVIEW: "Poolgroep eheerdersoverzicht",
  PR_SHARED_VEHICLE_GROUP_VEHICLE_OVERVIEW:
    "Overzicht poolgroepvoertuigen",
  PR_SHARED_VEHICLE_GROUP_DRIVER_OVERVIEW:
    "Poolgroep bstuurdersoverzicht",
  PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_GROUP_OVERVIEW:
    "Poolgroep contracttype groepsoverzicht",
  PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_OVERVIEW:
    "Poolgroep contracttype overzicht",
  PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW:
    "Poolgroepabonnementen overzicht",
  PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_AVAILIBILTY_RESTRICTION_OVERVIEW:
    "Beschikbaarheid poolgroepabbonementen overzicht",
  PR_SPECIAL_PERIODS: "Special Periods",
  PR_VEHICLES_OVERVIEW: "Vehicles Overview",
  PR_VEHICLE_SVG_OVERVIEW: "Voertuig poolgroepoverzicht",
  PR_VTS_VEHICLE_LIST: "VTS Vehicle List",
  PR_VTS_TROUBLESHOOT: "VTS Troubleshoot",
  PR_VEHICLE_ATTRIBUTE_CATEGORIES: "Voertuigkenmerkcategorieën",
  PR_VEHICLE_ATTRIBUTE: "Voertuigkenmerk",
  PR_ODOMETER_LOG_TRAIL: "Odometer Log Trail",
  PR_ODOMETER_LOG_TRAIL_REGISTERED_BY: "Odometer Log Trail Registered by",
  PR_DRIVER_OVERVIEW: "Driver Overview",
  PR_DRIVER_SHARED_VEHICLE_GROUP_OVERVIEW:
    "Overzicht bestuurder poolgroep",
  PR_DRIVER_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW:
    "Overzicht van de abonnementen voor de poolgroepbestuurders",
  PR_BOOKINGS_OVERVIEW: "Reserveringsoverzicht",
  PR_NORMAL_BOOKING: "Nieuwe reservering",
  PR_SPECIAL_BOOKING: "Special Booking",
  PR_TRIP_SIMULATOR: "Tripsimulator",
  PR_INVOICE: "Invoice",
  PR_DIRECT_DEBIT_FILE: "Incassobestand",
  PR_ADDITIONAL_FREE_ITEMS: "Additional Free Items",
  PR_TEST_INVOICE_GENERATOR: "Testfactuur generator",
  PR_VEHICLE_OCCUPANCY_REPORT: "Bezettingrapport voertuig",
  PR_REVENUE_PER_VEHICLE_REPORT: "Revenue Per Vehicle Report",
  PR_TRIP_DATA_REPORT: "Trip Data Report",
  PR_MAINTENANCE_PLANNING_REPORT: "Maintenance Planning Report",
  PR_SANIL_TRAIL_REPORT: "Snail Trail-rapport",
  PR_KICKBACK_REPORT: "Kickback rapport",
  PR_INVOICE_PAYMENT_HISTORY: "Factuur betalingsgeschiedenis",
  PR_TEMPLATES: "Sjablonen",
  PR_SIGNUP_FORMS_OVERVIEW: "Aanmeldingsformulieren overzicht",
  PR_SIGNUPS_OVERVIEW: "Signups Overview",
  PR_SIGNUP_OVERVIEW_TO_SIGNUP_FORM: "Aanmelden overzicht voor aanmeldingsformulier",
  PR_SIGNUP_OVERVIEW_TO_SHARED_VEHICLE_GROUP:
    "Aanmeldingsoverzicht aan poolgroep",
  PR_EVENT_VIEWER: "Gebeurtenissenoverzicht",
  PR_USER_PROFILE: "User Profile",
  PR_PRE_POST_TRIP_SETTING: "Begin en einde rit vragen instellingen",
  PR_PRE_POST_TRIP_QUESTIONS: "Begin en einde rit vragenoverzicht",
  PR_TERMS_AND_CONDITION: "Regels en voorwaarden",
  PR_PREPOST_TRIP_QUESTIONS_UPDATE: "Begin en einde rit vragen",
  LG_CUSTOMER: "Customer",
  LG_INSTANCE: "Instance",
  LG_BRANDING: "Branding",
  LG_PERSON: "Person",
  LG_COMPANY: "Company",
  LG_ORGANIZATION: "Organization",
  LG_SHARED_VEHICLE_GROUP: "Shared Vehicle Group",
  LG_VEHICLE: "Vehicle",
  LG_DRIVER: "Driver",
  LG_BOOKING: "Booking",
  LG_INVOICE: "Invoice",
  LG_REPORT: "Report",
  LG_TEMPLATE: "Sjabloon",
  LG_SIGNUP_FORM: "Signup Form",
  LG_EVENT_VIEWER: "Event Viewer",
  LG_PRE_POST_TRIP_SETTING: "Begin en einde rit vragen instellingen",
  LG_USER: "User",
  LG_BRANDING_AND_TEMPLATE: "Branding & sjablonen",
  LG_PREPOSTTRIPQUESTION: "Begin en einde rit vragen",
  LG_REPORTINGTOOL: "Rapportagetool",
  PR_BOOKING_OVERVIEW: "Boekingsoverzicht",
  PR_ROB_NOTIFICATIONS: "ROB Overzicht",
  PR_MILEAGE_OVERVIEW: "Kilometer overzicht",
  PR_USAGE_OVERVIEW: "Aantal dagen niet gebruikt",
  PR_POSITION_ON_MAP: "Positie op de kaart",
  PR_VEHICLE_ON_LOCATION_MAP: "Voertuig op locatie",
  PR_TRIP_OVERVIEW: "Ritregistratie",
  PR_ALTERNATE_TRANSPORTATION: "Vervangend vervoer",
  PR_AVERAGE_OVERVIEW: "Gemiddelden overzicht",
  PR_PRE_POST_BOOKING_OVERVIEW: "Pre/post vragen per boeking overzicht",
  PR_HOME_LOCATIONS_OVERVIEW: "Voertuig en SVG thuis locaties overzicht",

  //Vat Setting
  LblVatSettings: "BTW-instellingen",
  LblVatPercentages: "BTW Percentages",
  LblDefaultCost: "Standaard kosten weergeven en bewerken",
  LblExcludingVat: "Exclusief BTW",
  LblIncludingVat: "BTW inbegrepen",
  LblVatEnterDescription: "Voer omschrijving in",
  LblEnterVatPercentage: "Enter VAT %",
  LblVatPercentageError: "Please enter valid percentage",
  LblVatDescriptionError: "Please enter valid Description",
  LblStartDate: "Start Date",
  LblVatEndDate: "End Date",
  LblVatDeleteConfirmation: "Weet u zeker dat u de BTW-einddatum wilt instellen?",
  LblVatEndDateError: "Please enter VAT end date",
  LblVatEndDateNote: "Opmerking: gegevens worden uitgesloten vanaf de geselecteerde datum",
  LblVatStartDate: "Begindatum",
  LblVatStartDateError: "Please select start date",
  //

  LG_ROLE: "Role",
  PR_CUSTOMER_ADMIN_OVERVIEW: "Customer Admin Overview",
  PR_INSTANCE_ADMIN_OVERVIEW: "Instantie beheerdersoverzicht",
  PR_ROLE_OVERVIEW: "Role",
  PR_ROLE_ASSIGN: "Role Assign",
  PR_SHARED_VEHICLE_GROUP_ACTIVE_INACTIVE:
    "Poolgroep actief of inactief",
  PR_CUSTOMER_OVERVIEW: "Customer",
  PR_ORGANIZATION_SUBSCRIPTION_OVERVIEW: "Organisatie abonnementenoverzicht",
  PR_VTS_VEHICLE_EVENT_HISTORY: "VTS voertuig gebeurtenissen geschiedenis",
  PR_BATCH_UPLOAD_PERSON: "Personen batch-upload",
  PR_IMPORT_PERSON: "Import Person",
  PR_PRE_POST_TRIP_QUESTION_UPDATE: "Begin en einde rit vragen",
  LblPrivacyErrorMessage: "U bent niet gemachtigd om deze pagina te bekijken",
  LblPrivacyNavigate: "Navigeer a.u.b. naar",
  LblPrivacyError: "Privacy Error",
  LblLinkExpired: "Link Expired",
  LblLinkExpiredMessage:
    "Link is verlopen en kan niet meer worden gebruikt. Probeer het opnieuw.",
  LblBearer: "Bearer",
  LblWhoBenifitFreeItem: "Wie profiteert van abonnementscredits?",
  LblNoDistinction: "Default (no distinction)",
  LblPenaltyVat: "Boete BTW",
  LblTimeRateVat: "Time Rate VAT",
  LblMileageRateVat: "Kilometerprijs BTW",
  LblFixedFeeVat: "BTW over vaste kosten",
  LblSendInvoiceToOrganization: "Factuur verzenden naar organisatie",
  LblExpenseAmountVat: "Onkosten BTW",
  LblDefaultVatContractTypeGroupCost: "BTW% voor contracttype groepskosten",
  LblDefaultVatContractTypeCost: "BTW% voor contracttypekosten",
  LblDefaultVatSubscriptionCost: "VAT % for Subscription Costs",
  LblPenaltyCost: "Boetekosten",
  LblTimeRates: "Tijdtarieven",
  LblDistanceRates: "Distance Rates",
  LblFixedRates: "Fixed Rates",
  LblSubscriptionCost: "Subscription Costs",

  // template
  LblEmailTemplate: "E-mail sjabloon",
  LblWebTemplate: "Web Template",
  LblEmailAddressesEntryPattern:
    "Comma separated email addresses(like ex1@ex.com, ex2@ex.com)",
  LblNoRecipientWarning:
    "No recipients applicable. Default recipients will be the receiver of this template.",

  //MobileApp Configuration
  LblMobileAppConfiguration: "Mobile App Configuration",
  LblEnableNewBooking: "Enable New Booking",
  LblEnableBookingCalender: "Enable Booking Calender",
  LblEnableSubscription: "Enable Subscription",
  LblEnableUpdateProfile: "Schakel 'Profiel bijwerken' in",
  LblEnableNotification: "Enable Notification",
  LblEnableChangeBooking: "Schakel 'Boeking wijzigen' in",
  LblEnableAddExpenseMenu: "Schakel het menu 'Uitgaven toevoegen' in",
  LblChamberOfCommerce: "Kamer van Koophandel",
  LblInvoicingSettings: "Factureringsinstellingen",
  LblInvoiceSender: "Factuurverzender",

  LblCostAndExpenses: "Kosten en uitgaven",
  LblSender: "Afzender",
  LblAddressee: "Geadresseerde",
  LblAddLine: "Lijn toevoegen",
  LblSaveInvoice: "Factuur opslaan",
  LblVatAmount: "BTW bedrag",
  LblBookingId: "Boekings-ID",
  LblReceiptOrSuppor: "Bon of ondersteuning",
  LblVATPercentage: "BTW(%)",
  LblChargeTo: "In rekening brengen",
  LblReimburseTo: "Terugbetalen aan",
  LblReportedBy: "Gerapporteerd door",
  LblReportedAmount: "Gerapporteerde hoeveelheid",
  LblApprovedAmount: "Goedgekeurd bedrag",
  LblCostType: "Kostentype",
  LblRecipient: "Ontvanger",
  LblCostDetail: "Kostendetail",

  LblAddExisting: "Bestaande toevoegen",
  LblReceiptOrSupport: "Bon of ondersteuning",
  LblManualInvoiceLine: "Handmatige factuurregel",
  LblInvoiceLine: "Factuurregel",
  LblInvoice: "Factuur",
  LblInvoiceLines: "Factuurregels",
  LblSendInvoice: "Factuur verzenden",
  LblInvoiceSent: "Factuur verzonden",
  LblAddNewInvoiceLine: "Voeg een nieuwe factuurregel toe",
  LblSelectUnprocessedExpenses: "Selecteer een onverwerkte uitgave",
  LblSelectAtLeastOneExpense: "Selecteer ten minste één onkost",
  LblInvoicePaymentHistory: "Factuur betalingsgeschiedenis",
  LblPaymentMode: "Betaalmethode",
  LblLogTime: "Log tijd",
  PR_COST_EXPENSES: "Kosten en uitgaven",
  PR_COST_CENTER_REPORT: "Kostenplaatsrapport",

  LblInactiveAfterDays: "Inactief na (dagen)",
  LblMarkDeleteAfterDays: "Markeer Verwijderen na (dagen)",
  LblNotifyAdminBeforeDays: 'Beheerder voor "X" dagen informeren',
  LblGdprSettings: "GDPR-instellingen",
  LblRemovalDate: "Verwijderingsdatum",
  LblRemovePersonOn: "Persoon verwijderen op",

  LblNoPaymentLinkGenerated: "Geen betalingslink gegenereerd",
  //Payment Module
  LblPaymentConfig: "Betalingsconfiguratie",
  LblPaymentConfigButton: "Betalingsconfiguratie",
  LblPaymentProvider: "Betalingsprovider",
  LblCountry: "Land",
  LblEmailAddress: "E-mailadres",
  LblAllowPaymentConfiguration: "Betalingsconfiguratie toestaan",
  LblAllowPayment: "Betaling toestaan",
  LblPaymentSetting: "Betalingsproviderinstellingen",
  LblEnvironment: "Omgeving",
  LblInvoicePaymentTermDays: "Factuur betalingsvoorwaarden dagen",
  LblLinkValidityDays: "Link geldigheidsduur (dagen)",
  LblReportedOn: "Gerapporteerd op",
  LblPaymentMethods: "Betaalmethoden",
  LblPaymentProviderSecretKey: "PSP geheime sleutel",
  LblPaymentProviderUsername: "PSP gebruikersnaam (key)",
  LblCreditCardPayment: "Creditcard betaling",
  LblInitialPayment: "Voorschot",
  LblCreateBookingPayment: "Maak reserveringsbetaling aan",
  LblStartBookingPayment: "Start boeking Betaling",
  LblPaymentLink: "Betalingslink",
  LblPaymentHistory: "Betaalgeschiedenis",
  LblReasonOrganization: "Reden voor blokkering organisatie",
  LblDueDateUpdateSuccess: "Vervaldatum succesvol bijgewerkt",
  LblDueDateRequiredError: "Selecteer de vervaldatum.",
  LblDueDate: "Vervaldatum",
  LblConfirmDuedatechange: "Weet u zeker dat u de vervaldatum wilt bijwerken?",
  LblConfirmCloseInvoice: "Weet u zeker dat u de factuur wilt sluiten?",
  LblConfirmReOpenInvoice: "Weet u zeker dat u de factuur wilt heropenen?",
  LblInvoiceOpenCloseSuccess: "Factuur% 0 succesvol",
  LblReOpen: "Heropenen",
  LblClosed: "Gesloten",
  LblReOpenClose: "Open / sluit opnieuw",
  PR_PAYMENT_HISTORY_LIST: "Betaalgeschiedenis",
  LblUserBlockMessage: "Reden voor blokkering gebruiker",
  PR_BLOCK_UNBLOCK_ORGANIZATION: "Blokkeer / de-blokkeer organisatie",
  LblWhenOpeningAppAndRepeat:
    "Bij het openen van de app voor de eerste keer en herhaal elke",
  LblEveryTimeOpenApp: "Elke keer dat de app wordt geopend",
  LblWhenMakeBooking: "Bij het maken van een boeking",
  LblWhenStartBooking: "Bij het starten van een boeking",
  LblWhenOpenBooking: "Bij het openen van een voertuig",
  LblSelectContractTypeGroup:
    "Bij het kiezen van een specifieke contracttype groep (en)",
  LblDays: "Dagen",
  LblNewVersion: "Nieuwe versie",
  LblAction: "Actie",
  LblTAndCName: "T &C naam",
  LblOldVersion: "Oude versie",
  LblSureToRevoke: "Weet je zeker dat %0 wordt ingetrokken?",
  LblCurrencyConfiguration: "Valutaconfiguratie",
  LblNameSingular: "Naam enkelvoud",

  //Special Period
  LblRegularBooking: "Reguliere boeking",
  LblSpecialRate: "Speciaal tarief",
  LblFirstDay: "Eerste dag",
  LblLastDay: "Laatste dag",
  LblWeekEndContaining: "Weekend met",
  LblNamePlural: "Naam meervoud",
  LblSignBeforeAmount: "Valutasymbool vóór bedrag",
  LblOutOf: "buiten",

  //Credit card payment
  LblCrediCardPayment: "Creditcard betaling",
  LblFirstBooking: "Eerste boeking",
  LblAllowRecurringPayment: "Authoriseer creditcard",
  LblProceed: "Doorgaan",
  LblCheckAllowPayment: "Controleer of het is toegestaan ​​om een ​​periodieke betaling toe te staan",
  LblPaymentFailed: "Authoriseer creditcard",
  LblPaymentSuccess: "Authorisatie gelukt",
  LblPaymentFailure: "Authorisatiefout",
  LblCompletedSuccess: "Uw authorisatie is succesvol verwerkt",

  LblCompletedFailure:
    "Uw authorisatie is mislukt. Ga terug en probeer het alstublieft opnieuw.",
  LblCreditCardNumber: "Creditcardnummer",
  LblCreditCardExpirationDate: "Creditcard Vervaldatum",
  LblCreditCardDetails: "Creditcard details",
  LblMakePayment: "Authoriseer creditcard",
  LblAdminPaymentConfirmation:
    "Er is geen actieve authorisatie of een betaling is mislukt. Wilt u doorgaan?",
  LblPaymentDescription:
    "Om een ​​voertuig te boeken, is een verificatiebetaling van %0 vereist. Daarnaast is de toestemming vereist om toekomstige betalingen van uw creditcard af te trekken. Betalingen worden verwerkt door onze betaalprovider Buckaroo. U wordt doorverwezen naar de Buckaroo-website voor de daadwerkelijke betaling. ",
  LblPay: "Betalen",

  // NIF Number
  LblEnableNIFNumber: "Schakel NIF-nummer in",
  LblNIFNumber: "NIF-nummer",
  LblWeGoDefault: "WeGo Standaard",
  LblPersonActiveSuccess: "Persoon met succes geactiveerd",
  LblActivate: 'Activeren',
  LblInActiveReason: "InActive Reason",
  LblDefaultLanguage: 'Standaardtaal',
  LblRestoreInheritConfirmation: "De huidige instellingen worden overschreven door de overgenomen instellingen. Weet u het zeker?",
  LblQestionTextRequired: "Tekst met vraag vereist",
  LblManualSecretKey: "Geheime sleutel",

  // Two Factor Authentication
  LblTwoFaConfig: "Twee-factorauthenticatie",
  LblEnableTwoFa: "Schakel twee-factorauthenticatie in",
  LblExpirationDays: "Vervaldagen",
  LblTextBoxExpirationDays: "Vervaldagen",
  Lbl2FactorAuthenticateExpDays: "2FA-vervaltermijn (dagen):",
  LblResetCookiesWegoAdmin: "Reset cookies voor alle WeGo-beheerders",
  LblReset2FactorAuthWegoAdmin: "Reset 2FA voor alle WeGo-beheerders",
  LblAuthentication: "Authenticatie",
  LblResetCookiesForAllAdmin: "Reset cookies voor alle beheerders",
  LblReset2FaForAllAdmin: "Reset 2FA voor alle beheerders",
  LblEnterTotp: "Voer alstublieft de code in",
  LblEnterOtp: "Voer alstublieft de code in",
  LblSubmit: "Verstuur",
  LblKeyResetSuccess: "2FA sleutel is gereset",
  LblKeyResetFailed: "2FA sleutel resetten mislukt",
  LblCookieResetSuccess: "2FA cookies zijn gereset",
  LblCookieResetFailed: "2FA cookies resetten mislukt",
  LblGoogleAuthenticator: "Google Authenticator-app",
  LblEmailOtpSent: "Er is een code verzonden naar uw geregistreerde e-mailadres",
  LblContinue: "Doorgaan",
  LblInvalidTOTP: "Ongeldige code",
  LblResetCookie: "Reset Cookie",
  LblResetTwoFA: "Reset 2FA",
  LblDisableTwoFA: "Schakel 2FA uit",
  LblTwoFaMethod: "2FA methode",
  LblEmailAuthentication: "E-mail authenticatie",
  LblTwoFaMethodSelect: "U moet uw identiteit nog een keer verifiëren. Selecteer alstublieft uw 2FA methode",
  LblMissingInvoiceGenerator: "Ontbrekende factuurgenerator",
  LblInvoicePreFix: "Factuurnummer voorvoegsel",
  LblEngineStillRunning: 'Vergrendelopdracht verzonden terwijl de motor draait',
  LblMobileAppLink: "Mobile App Link",

  // License Check Configuration
  LblLicenseCheckConfiguration: "Rijbewijs Check Configuratie",
  LblValidateLicenseCheckForBooking: "Check voor boeking",

  // Access Cards Enabled SVG
  LblAccessCardsEnabled: "Gebruik toegangspas",

  // Track & Trace
  LblTrackAndTrace: "Track & Trace",
  LblRfidTagId: "RFID Tag ID",
  LblEmployeeNumber: "Werknemersnummer",

  // Access Card
  LblAccessCardId: "Pas ID",  

  BtnAddVehicleInfo: "Laat vts log zien",
  LblDriversLicenseAndCertificates: "Rijbewijs en certificaten",
  LblLicense: "Rijbewijs",
  LblCertificates: "Certificaten",

  LblTrips: "Trips",
  LblCostsSummary: "Kosten overzicht",
  LblStartBooking: "Start boeking",
  LblStopBooking: "Stop boeking",

  LblTripHistory: "Ritgeschiedenis",
  LblTripStartDateTime : "Van",
  LblTripEndDateTime: "Tot",
  LblFaZTripQuestions: "FaZ vragen",
  LblNoQuestionsFound: "Geen FaZ-vragen gevonden.",
  LblNoTripsFound: "Geen ritten gevonden.",
  LblTripDetails: "Ritdetails",
  LblUnansweredQuestions: "Onbeantwoorde vragen",
  LblNoUnansweredQuestions: "Geen onbeantwoorde vragen",
  LblAnswerSaved: "Het antwoord is succesvol opgeslagen",
  LblAnswerSavedError: "Het antwoord kon niet worden opgeslagen. Neem dan contact op met de beheerder",
  LblAnswerEmptyError: "Voer een geldig antwoord in",

  LblLoginError: "Er is een onbekende fout opgetreden bij het inloggen",
  LblLoginCredentialsError: "Deze gebruikersnaam of wachtwoord is ongeldig, controleer uw gegevens en probeer opnieuw",
  LblBookingStarted: "De boeking is gestart",
  LblCouldnotStartBooking: "De boeking kan niet gestart worden.",
  LblBookingStopped: "De boeking is gestopt",
  LblCouldnotStopBooking: "De boeking kan niet gestopt worden",
  LblInfo: "Info",
  ValidatePhoneNumberVts: "Voer een geldig telefoonnummer in (b.v. +31623456789)",
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/translate/lang-nl.ts